import { f as flow } from '../ReadonlyNonEmptyArray-0e481d0b.js';
import { Node_Type } from 'ricos-schema';
import { getExtractor } from '../extractor-infra.js';
import '../Either-48abb652.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';

const nodesAccessor = (node) => Array.isArray(node.nodes) ? node.nodes : [];
const getRootNode = (nodes) => Array.isArray(nodes) ? {
  id: "root",
  type: Node_Type.UNRECOGNIZED,
  nodes
} : nodes;
const extract = flow(
  getRootNode,
  getExtractor(nodesAccessor)
);

export { extract };
//# sourceMappingURL=extract.js.map
